import type { AnyFn } from '@vueuse/core'

export enum IOSEventName {
  INSTALL_CERTIFICATE = 'installCertificate',
  RETURN_TO_APP = 'returnToApp',
  DOWNLOAD_FILE = 'downloadFile',
  EXPORT_FILE_LIST = 'exportFileList',
}

export interface IOSWebViewJavascriptBridge {
  messageHandlers?: {
    [eventName: string]: {
      postMessage: (data: any) => void
    }
  }
}

export class NativeBridge {
  private static _instance: NativeBridge

  public static getInstance(): NativeBridge {
    if (!NativeBridge._instance) {
      NativeBridge._instance = new NativeBridge()
    }

    return NativeBridge._instance
  }

  public callNativeMethod<T>(eventName: IOSEventName, data?: T): void {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[eventName]) {
      window.webkit.messageHandlers[eventName].postMessage(data ?? null)
    } else {
      console.log(`[callNativeMethod:] Native method [${eventName}]  not found.  ${new Date().toLocaleString()}`, data)
    }
  }

  public registerNativeMethod(methodName: string, method: AnyFn): void {
    window[methodName] = method
  }
}
